// vue
import Vue from "vue";
import { mapGetters } from "vuex";

// services
import { EventTrackingService, ObjectUtil, ShoppingCartService, Task } from "@/services";

// components
import { IShoppingCartContext } from "../../Types";
import { default as PartListing } from "../PartListing.vue";

// types

export default Vue.extend({
  name: "ClearCartConfirmationDialog",
  components: {
    PartListing,
  },
  props: {
    context: {
      type: Object,
      default: () => ObjectUtil.createInstance<IShoppingCartContext>(),
    },
  },
  computed: {
    ...mapGetters(["getContentItem"]),
  },
  mounted() {
    EventTrackingService.trackEvent({
      category: "Shopping Cart",
      action: "EmptyCart",
      label: "User clicked empty cart",
    });
  },
  methods: {
    async emptyCartClicked() {
      this.$emit("on-cart-clearing");

      try {
        const context = this.context as IShoppingCartContext;

        const rq = {
          accountId: context.accountId,
          userId: context.user.UserId,
          shoppingCartId: context.cartId,
        };

        const result = await ShoppingCartService.EmptyCart(rq);

        EventTrackingService.trackEvent({
          category: "Shopping Cart",
          action: "EmptyCart",
          label: "User confirmed empty cart",
        });

        await Task.Delay(100);

        this.$emit("on-cart-cleared", result);
      } catch (err) {
        this.$emit("on-error", err);
      }
    },

    cancel() {
      this.$emit("on-cancel");
    },
  },
});
